import React from 'react';

import { StyleSheet } from 'react-native';

import { Box, BoxProps } from 'components/ui';
import { spacing } from 'styles/constants';

export const BlockContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.blockContainer, style] });

const styles = StyleSheet.create({
  blockContainer: {
    alignSelf: 'center',
    maxWidth: 912,
    paddingHorizontal: spacing.$4,
    width: '100%',
  },
});
